import { SERVER } from 'config'

export const DEFAULT_LOGO_SRC = `${process.env.PUBLIC_URL}/greenamex-logo.png`

export const isLegacyLogoValue = logo => typeof logo === 'string' && logo.startsWith('data:image/vnd.microsoft.icon')

export const getLogoPreviewSrc = logo => {
  if (!logo || isLegacyLogoValue(logo)) return DEFAULT_LOGO_SRC
  if (typeof logo === 'string' && logo.startsWith('/api/')) return `${SERVER.url}${logo}`
  return logo
}
